import { render, staticRenderFns } from "./audit-users.vue?vue&type=template&id=d6796b10"
import script from "./audit-users.vue?vue&type=script&lang=js"
export * from "./audit-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports